import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { UpdateIconColorModel } from '@smarttask-common/src/lib/models/General/UpdateIconColorModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class PortfolioHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.portfolio_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.portfolio_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.portfolio_create, (portfolio_id) => {
            this.broadcast(SharedEventNameEnum.portfolio_create, { portfolio_id });
        });

        this.on(SharedEventNameEnum.portfolio_name_update, (portfolio_id: string, name: string) => {
            this.broadcast(SharedEventNameEnum.portfolio_name_update, { portfolio_id, name });
        });

        this.on(SharedEventNameEnum.portfolio_icon_color_update, (portfolio_id: string, model: UpdateIconColorModel) => {
            this.broadcast(SharedEventNameEnum.portfolio_icon_color_update, { portfolio_id, model });
        });

        this.on(SharedEventNameEnum.portfolio_order_update, (portfolio_id: string, order_index: number) => {
            this.broadcast(SharedEventNameEnum.portfolio_order_update, { portfolio_id, order_index });
        });

        this.on(SharedEventNameEnum.portfolio_column_upsert, (portfolio_id: string, column_id: string) => {
            this.broadcast(SharedEventNameEnum.portfolio_column_upsert, { portfolio_id, column_id });
        });

        this.on(SharedEventNameEnum.portfolio_column_delete, (portfolio_id: string, column_id: string) => {
            this.broadcast(SharedEventNameEnum.portfolio_column_delete, { portfolio_id, column_id });
        });

        this.on(SharedEventNameEnum.portfolio_delete, (portfolio_id: string, user_ids: number[]) => {
            this.broadcast(SharedEventNameEnum.portfolio_delete, { portfolio_id, user_ids });
        });

        this.on(SharedEventNameEnum.portfolio_projects_add, (portfolio_id: string, project_ids: string[]) => {
            this.broadcast(SharedEventNameEnum.portfolio_projects_add, { portfolio_id, project_ids });
        });

        this.on(SharedEventNameEnum.portfolio_project_order_update, (portfolio_id: string, project_id: string, order_index: number) => {
            this.broadcast(SharedEventNameEnum.portfolio_project_order_update, { portfolio_id, project_id, order_index });
        });

        this.on(SharedEventNameEnum.portfolio_project_remove, (portfolio_id: string, project_id: string) => {
            this.broadcast(SharedEventNameEnum.portfolio_project_remove, { portfolio_id, project_id });
        });
    };
}
